/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface OtherSystemSourceInsight
 */
export interface OtherSystemSourceInsight {
    /**
     * 
     * @type {string}
     * @memberof OtherSystemSourceInsight
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherSystemSourceInsight
     */
    since?: string;
    /**
     * 
     * @type {string}
     * @memberof OtherSystemSourceInsight
     */
    until?: string;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof OtherSystemSourceInsight
     */
    spend?: MoneyOutput;
    /**
     * 
     * @type {string}
     * @memberof OtherSystemSourceInsight
     */
    note?: string | null;
}

/**
 * Check if a given object implements the OtherSystemSourceInsight interface.
 */
export function instanceOfOtherSystemSourceInsight(value: object): value is OtherSystemSourceInsight {
    return true;
}

export function OtherSystemSourceInsightFromJSON(json: any): OtherSystemSourceInsight {
    return OtherSystemSourceInsightFromJSONTyped(json, false);
}

export function OtherSystemSourceInsightFromJSONTyped(json: any, ignoreDiscriminator: boolean): OtherSystemSourceInsight {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'since': json['since'] == null ? undefined : json['since'],
        'until': json['until'] == null ? undefined : json['until'],
        'spend': json['spend'] == null ? undefined : MoneyOutputFromJSON(json['spend']),
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function OtherSystemSourceInsightToJSON(json: any): OtherSystemSourceInsight {
    return OtherSystemSourceInsightToJSONTyped(json, false);
}

export function OtherSystemSourceInsightToJSONTyped(value?: OtherSystemSourceInsight | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'since': value['since'],
        'until': value['until'],
        'spend': MoneyOutputToJSON(value['spend']),
        'note': value['note'],
    };
}

